var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-accounting-journal-table',{attrs:{"title":_vm.$t('global.models.accounting-journal.heading'),"subtitle":_vm.$t('global.models.accounting-journal.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }